function removeUnwantedCharacters(value) {
  const args = value ?? '';

  return Array.isArray(args) ? value.map(removeUnwantedCharacters) : removeCharacters(args);
}

function removeCharacters(value) {
  if (typeof value === 'object') {
    const { keyField } = value;
    if (!keyField) return value;
    return { ...value, [keyField]: removeUnwantedCharacters(value[keyField]) };
  }

  return String(value).replace(/^\|\s/, '').replace(/\|$/, '').trim();
}

export default removeUnwantedCharacters;
